module.exports = __webpack_public_path__ + "img/illustrations-error.a8740522.svg";